import { render, staticRenderFns } from "./UserCustomPrice.vue?vue&type=template&id=38dc83cc"
import script from "./UserCustomPrice.vue?vue&type=script&lang=js"
export * from "./UserCustomPrice.vue?vue&type=script&lang=js"
import style0 from "./UserCustomPrice.vue?vue&type=style&index=0&id=38dc83cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports